import React, { useEffect,  useState } from "react";

import Cookies from "js-cookie";
import { useDispatch, useSelector } from "react-redux";
import { Col, Row, Offcanvas, Button } from "react-bootstrap";
import PayRollFilterBox from "../../../components/FilterBox/PayRollFilter/PayRollFilter";
import { FiMenu } from "react-icons/fi";
import PayRollChart from "../../../components/Charts/PayRollChart";
import { Loader } from "../../../components/Loader/Loader";
import {
  DeptGrpSaldataFun,
  DeptGrpSalTotal,
} from "../../../Redux/Slice/PayRoll/PayRollSlice";
import PayRollParentChild from "../../../components/Tables/PayRollParentChild";
import { useTheme } from "../../../Themecontext/Themecontext";

export const SalaryAnalysisDashboard = () => {
  const dispatch = useDispatch();
  const { Colourdata, DataMain } = useSelector((state) => state.ClientLogin);
  const [isFilterLoading, setIsFilterLoading] = useState(false);
  const { DeptGrpSaldata } = useSelector((state) => state.PayRollSlice || {});

  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "NEWPAYROLL");
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWPAYROLLDARK",
  );
  const { theme } = useTheme();
  const isdark = theme;

  const Firm = Cookies.get("Firm");

  useEffect(() => {
    const defaultYear = Cookies.get("FinancialYear");

    dispatch(
      DeptGrpSalTotal({
        Firm: Firm,
        Year: defaultYear,
        MonthIDs: "",
      }),
    );

    dispatch(
      DeptGrpSaldataFun({
        Firm: Firm,
        Year: defaultYear,
        MonthIDs: "",
      }),
    );
  }, [dispatch, Firm]);

  const [search, setSearch] = useState({
    year: "",
    month: "",
  });

  const [filters, setFilters] = useState({
    year: [],
    month: [],
  });

  const monthOptions = [
    { id: 4, month: "April" },
    { id: 5, month: "May" },
    { id: 6, month: "June" },
    { id: 7, month: "July" },
    { id: 8, month: "August" },
    { id: 9, month: "September" },
    { id: 10, month: "October" },
    { id: 11, month: "November" },
    { id: 12, month: "December" },
    { id: 1, month: "January" },
    { id: 2, month: "February" },
    { id: 3, month: "March" },
  ];

  const [showFilter, setShowFilter] = useState(false);
  const handleClose = () => setShowFilter(false);
  const handleShow = () => setShowFilter(true);

  const toggleItem = (type, item) => {
    setFilters((prev) => {
      const selected = prev[type];

      return {
        ...prev,
        [type]: selected.includes(item.value)
          ? selected.filter((i) => i !== item.value)
          : [...selected, item.value],
      };
    });
  };
  const selectAll = (type, items) => {
    const allIds = items.map((i) => i.value);

    setFilters((prev) => ({
      ...prev,
      [type]: prev[type].length === items.length ? [] : allIds,
    }));
  };
  const handleSearch = (type, value) => {
    setSearch((prev) => ({
      ...prev,
      [type]: value,
    }));
  };

  const chartData =
    DeptGrpSaldata?.Dtl?.map((item) => ({
      label: item.DeptGrpName,
      value: item.TotalSalary,
    })) || [];

  const applyFilters = async () => {
    setIsFilterLoading(true);

    const MonthIDs = filters.month.toString();

    const finalYear =
      filters.year.length === 0
        ? Cookies.get("FinancialYear")
        : filters.year.toString();

    try {
      await Promise.all([
        dispatch(
          DeptGrpSaldataFun({
            Firm: Firm,
            Year: finalYear,
            MonthIDs: MonthIDs,
          }),
        ),
        dispatch(
          DeptGrpSalTotal({
            Firm: Firm,
            Year: finalYear,
            MonthIDs: MonthIDs,
          }),
        ),
      ]);
    } finally {
      setIsFilterLoading(false);
    }
  };

  const yearList =
    DataMain?.AC_Year_List?.map((item) => ({
      label: item?.AcYear,
      value: item?.AcYearID,
    })) || [];
  const monthList =
    monthOptions?.map((item) => ({
      label: item?.month,
      value: item?.id,
    })) || [];

  const formatIndian = (amount) => {
    if (!amount && amount !== 0) return "";
    return Number(amount).toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const initialData = (DeptGrpSaldata?.Dtl || []).map((row, index) => ({
    srNumber: index + 1,
    DeptGrpName: row.DeptGrpName,
    DeptName: row.DeptName,
    NoOfEmployees: row.NoOfEmpl,
    TotalSalary: row.TotalSalary,
    PT: row.PT,
    PF: row.PF,
    ESI: row.ESI,
    OtherLess: row.OtherLess,
    OtherEarning: row.OtherEarning,
    NetSalary: row.NetSalary,
  }));

  const columns = [
    { key: "srNumber", label: "Sr. No.", align: "center" },
    {
      key: "DeptGrpName",
      label: "DeptGrp Name",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    {
      key: "DeptName",
      label: "Department Name",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    { label: "count", key: "count" },
    { key: "NoOfEmployees", label: "No Of Employees", align: "right" },
    {
      key: "TotalSalary",
      label: "Total Salary",
      align: "right",
      format: "true",
    },
    { key: "PT", label: "PT", align: "right", format: "true" },
    { key: "PF", label: "PF", align: "right", format: "true" },
    { key: "ESI", label: "ESI", align: "right", format: "true" },
    { key: "OtherLess", label: "Other Less", align: "right", format: "true" },
    {
      key: "OtherEarning",
      label: "Other Earning",
      align: "right",
      format: "true",
    },
    { key: "NetSalary", label: "Net Salary", align: "right", format: "true" },
  ];

  const cardStyle = {
    background: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour2,
    border: `1px solid ${
      isdark === "light" ? iscolour?.Colour3 : iscolourDark?.Colour10
    }`,
    borderLeft: `6px solid ${
      isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour10
    }`,
    borderRadius: "12px",
    padding: "10px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    height: "100%",
  };

  const titleStyle = {
    color: isdark === "light" ? iscolour?.Colour12 : iscolourDark?.Colour12,
    fontWeight: "600",
  };

  const subtitleStyle = {
    marginTop: "10px",
    fontWeight: "500",
    color: isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour10,
  };

  if (DataMain === null) {
    return (
      <div className="flex justify-center items-center h-screen text-xl text-green-700">
        <Loader />
      </div>
    );
  }

  if (DeptGrpSaldata === "no" || DeptGrpSaldata === null) {
    return (
      <div className="flex justify-center items-center h-screen text-xl text-green-700">
        <Loader />
      </div>
    );
  }

  return (
    <div
      style={{
        padding: "16px",
        background:
          isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour2,
        minHeight: "100vh",
      }}
    >
      {/* MOBILE BUTTON */}
      <div className="d-lg-none d-flex justify-content-end mb-3">
        <Button
          onClick={handleShow}
          style={{
            backgroundColor:
              isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour7,
            color:
              isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour12,
            border: "none",
            borderRadius: "10px",
            padding: "8px 12px",
            boxShadow: "0 4px 10px rgba(0,0,0,0.18)",
          }}
        >
          <FiMenu size={22} />
        </Button>
      </div>

      {/* OFFCANVAS */}
      <Offcanvas
        show={showFilter}
        onHide={handleClose}
        placement="start"
        style={{
          background:
            isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour2,
        }}
      >
        <Offcanvas.Header
          closeButton
          closeVariant={isdark === "dark" ? "white" : undefined}
        >
          <Offcanvas.Title
            style={{
              color:
                isdark === "light"
                  ? iscolour?.Colour12
                  : iscolourDark?.Colour12,
            }}
          >
            Filters
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div
            style={{ display: "flex", flexDirection: "column", gap: "20px" }}
          >
            <PayRollFilterBox
              title="Year"
              items={yearList}
              search={search.year}
              setSearch={(val) => handleSearch("year", val)}
              selectedItems={filters.year}
              toggleItem={(item) => toggleItem("year", item)}
              selectAll={() => selectAll("year", yearList)}
            />

            {/* ✅ MONTH FILTER */}
            <PayRollFilterBox
              title="Month"
              items={monthList}
              search={search.month}
              setSearch={(val) => handleSearch("month", val)}
              selectedItems={filters.month}
              toggleItem={(item) => toggleItem("month", item)}
              selectAll={() => selectAll("month", monthList)}
            />
            <Button
              onClick={applyFilters}
              style={{
                width: "100%",
                height: "44px",
                borderRadius: "10px",
                background:
                  isdark === "light"
                    ? iscolour?.Colour6
                    : iscolourDark?.Colour7,
                border: "none",
                fontWeight: "600",
              }}
              className="common-hover-btn"
            >
              Apply Filters
            </Button>
          </div>
        </Offcanvas.Body>
      </Offcanvas>

      <Row className="g-4">
        {/* FILTER */}
        <Col xl={3} lg={4} className="d-none d-lg-block">
          <div
            style={{ display: "flex", flexDirection: "column", gap: "20px" }}
          >
            <PayRollFilterBox
              title="Year"
              items={yearList}
              search={search.year}
              setSearch={(val) => handleSearch("year", val)}
              selectedItems={filters.year}
              toggleItem={(item) => toggleItem("year", item)}
              selectAll={() => selectAll("year", yearList)}
            />

            {/* ✅ MONTH FILTER */}
            <PayRollFilterBox
              title="Month"
              items={monthList}
              search={search.month}
              setSearch={(val) => handleSearch("month", val)}
              selectedItems={filters.month}
              toggleItem={(item) => toggleItem("month", item)}
              selectAll={() => selectAll("month", monthList)}
            />
            <Button
              onClick={applyFilters}
              style={{
                width: "100%",
                height: "44px",
                borderRadius: "10px",
                background:
                  isdark === "light"
                    ? iscolour?.Colour6
                    : iscolourDark?.Colour7,
                border: "none",
                fontWeight: "600",
              }}
              className="common-hover-btn"
            >
              Apply Filters
            </Button>
          </div>
        </Col>

        {/* RIGHT SIDE */}
        <Col xl={9} lg={8}>
          {isFilterLoading && (
            <div
              style={{
                position: "absolute",
                inset: 0,
                background: "rgba(255,255,255,0.7)",
                zIndex: 999,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "14px",
              }}
            >
              <Loader />
            </div>
          )}

          {/* SUMMARY */}
          <Row className="g-3">
            <Col xl={6} lg={12} md={12} sm={12}>
              <div style={cardStyle}>
                <h4 style={subtitleStyle}>
                  {formatIndian(DeptGrpSaldata?.Summ?.[0]?.TotalSalary)}
                </h4>
                <h6 style={titleStyle}>Total Salary Amount</h6>
              </div>
            </Col>

            <Col xl={6} lg={12} md={12} sm={12}>
              <div style={cardStyle}>
                <h4 style={subtitleStyle}>
                  {DeptGrpSaldata?.Summ?.[0]?.TotalEmpl}
                </h4>
                <h6 style={titleStyle}>Total Number of Employees</h6>
              </div>
            </Col>
          </Row>

          {/* Chart */}
          <div
            style={{
              marginTop: "20px",
              borderRadius: "12px",
              overflow: "hidden",
              boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
            }}
          >
            <div
              style={{
                background:
                  isdark === "light"
                    ? iscolour?.Colour6
                    : iscolourDark?.Colour7,
                color:
                  isdark === "light"
                    ? iscolour?.Colour1
                    : iscolourDark?.Colour12,
                padding: "14px",
                fontWeight: "600",
                fontSize: "18px",
                margin: 0,
                letterSpacing: "1px",
              }}
            >
              CHART
            </div>

            <PayRollChart data={chartData} />
          </div>

          {/* \ TABLE */}
          <div
            style={{
              marginTop: "20px",
              borderRadius: "12px",
              overflow: "hidden",
              boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
            }}
          >
            <div
              style={{
                padding: "14px",
                background:
                  isdark === "light"
                    ? iscolour?.Colour6
                    : iscolourDark?.Colour7,
                color:
                  isdark === "light"
                    ? iscolour?.Colour1
                    : iscolourDark?.Colour12,
                fontWeight: "600",
                fontSize: "18px",
                margin: 0,
                letterSpacing: "1px",
              }}
            >
              SALARY ANALYSIS
            </div>

            <PayRollParentChild
              data={initialData}
              columns={columns}
              parentKey="DeptGrpName"
            />
          </div>
        </Col>
      </Row>
    </div>
  );
};
